export default __webpack_public_path__ + "static/winter-holidays_1-0d180f906d3264f124b810ab36db71d4.png";